import decimalNumberFormatter from "./decimalNumberFormatter";

export default function creditMessageFormatter(addOnData, remainingAmount, messageDescription) {
  let newMessage = messageDescription;
  try {
    let amount = Math.trunc(remainingAmount);
    if (amount > 0) {
      const newPrice = `$${decimalNumberFormatter(amount)}`;
      const regex = /\$\d+/;
      newMessage = addOnData.content.isBillCreditApplicable.message.replace(regex, newPrice)
      return newMessage
    } else {
      return newMessage;
    }
  } catch (err) {
    console.log("Logging error- ", err, "bill credit functionality issue");
  }
}